var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcPlus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Group_16",
    "data-name": "Group 16",
    viewBox: "0 0 14 14"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Line_22",
    d: "M14 0H0",
    className: "cls-1",
    "data-name": "Line 22",
    transform: "translate(0 7)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Line_23",
    d: "M14 0H0",
    className: "cls-1",
    "data-name": "Line 23",
    transform: "rotate(90 3.5 3.5)"
  })));
}
export default __webpack_public_path__ + "static/media/ic_plus.01943e84.svg";
export { SvgIcPlus as ReactComponent };